import { render, staticRenderFns } from "./LocationSettingsPage.vue?vue&type=template&id=2d4f283f&scoped=true"
import script from "./LocationSettingsPage.vue?vue&type=script&lang=js"
export * from "./LocationSettingsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4f283f",
  null
  
)

export default component.exports